module.exports = __webpack_public_path__ + "fonts/AmplitudeTF-BoldItalic_1_7eed40c2.c8cba01d.eot";